import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HeaderService } from './header.service';

@Component({
    selector: 'emreg-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],

})

export class HeaderComponent implements OnInit {

    constructor(
        private _translateService: TranslateService,
        private _headerService: HeaderService
    ) {
    }

    ngOnInit(): void {
    }

    getTwoLetterCulture(): string {
        return sessionStorage.getItem('currentCulture').substr(0, 2);
    }

    toggleLanguage(): void {
        let cultureString = sessionStorage.getItem('currentCulture');
        const preFileName = sessionStorage.getItem('preFileName');

        if (cultureString == 'en-CA') { cultureString = 'fr-CA'; }
        else { cultureString = 'en-CA'; }

        this._translateService.use(preFileName + cultureString);
        sessionStorage.setItem('currentCulture', cultureString);

        this._headerService.setLanguage('');
    }
}
